// Configure worker
globalThis.pdfjsLib.GlobalWorkerOptions.workerSrc = '/public/javascripts/vendor/pdfjs/pdf.worker.min.mjs';

const params = new URLSearchParams(window.location.search);
const url = params.get('file');

let pdfDoc = null;
let scale = 1;

const $viewer = $('#viewer');
const $pageInfo = $('#page-info');
const $zoomSelect = $('#zoom-select');
const $fullscreenBtn = $('#fullscreen');
const $pageInput = $('#page-input');
const $numPages = $('#num-pages');
const $zoomMinus = $('#zoom-minus');
const $zoomPlus = $('#zoom-plus');

// Load PDF
globalThis.pdfjsLib.getDocument({
    url: url,
    standardFontDataUrl: 'public/fonts/pdfjs/'
}).promise.then(pdf => {
    pdfDoc = pdf;
    $numPages.text(pdfDoc.numPages);
    $viewer.removeClass('loader saving');
    initCanvas();
});

function renderAllPages() {
    for (let i = 1; i <= pdfDoc.numPages; i++) {
        const canvas = document.createElement('canvas');
        canvas.dataset.pageNum = i;
        $viewer.append(canvas);
        renderPage(i, canvas);
    }
}

function renderPage(num, canvas) {
    pdfDoc.getPage(num).then(page => {
        const viewport = page.getViewport({ scale });
        const dpr = window.devicePixelRatio || 1;

        canvas.width = viewport.width * dpr;
        canvas.height = viewport.height * dpr;
        canvas.style.width = `${viewport.width}px`;
        canvas.style.height = `${viewport.height}px`;

        const context = canvas.getContext('2d');
        context.setTransform(dpr, 0, 0, dpr, 0, 0);

        page.render({ canvasContext: context, viewport });
    });
}

$(window).on('scroll', function() {
    if (!pdfDoc) return;

    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    let closestPage = null;
    let closestDistance = Infinity;

    $('#viewer canvas').each(function() {
        const $canvas = $(this);
        const offsetTop = $canvas.offset().top;
        const canvasHeight = $canvas.height();
        const canvasCenter = offsetTop + canvasHeight / 2;

        const distance = Math.abs(canvasCenter - (scrollTop + windowHeight / 2));

        if (distance < closestDistance) {
            closestDistance = distance;
            closestPage = this;
        }
    });

    if (closestPage) {
        const currentPageNum = parseInt($(closestPage).attr('data-page-num'), 10);
        $('#page-input').val(currentPageNum);
    }
});

function setScale(newScale) {
    $zoomSelect.find('.temp-option').remove();
    scale = newScale;
    rerender();
}

function rerender() {
    $viewer.find('canvas').each(function() {
        renderPage(parseInt($(this).attr('data-page-num'), 10), this);
    });
}

$zoomSelect.on('change', function() {
    let val = $(this).val();
    if (val === 'page-fit') {
        pdfDoc.getPage(1).then(p => {
            const vp = p.getViewport({ scale: 1 });
            const height = window.innerHeight - 100;
            setScale(height / vp.height);
        });
    } else if (val === 'page-width') {
        pdfDoc.getPage(1).then(p => {
            const vp = p.getViewport({ scale: 1 });
            const width = $viewer.width() - 40;
            setScale(width / vp.width);
        });
    } else {
        setScale(parseFloat(val));
    }
});

$zoomPlus.on('click', function() {
    let newScale = roundToNearest10(scale + 0.1);
    setScale(newScale);
    setSelectValue($zoomSelect, scale);
});

$zoomMinus.on('click', function() {
    let newScale = roundToNearest10(scale - 0.1);
    setScale(newScale);
    setSelectValue($zoomSelect, scale);
});

$fullscreenBtn.on('click', function() {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
        document.exitFullscreen();
    }
});

$pageInput.on('keypress', function(e) {
    if (e.which === 13) { // Enter key
        $(this).trigger('blur');
    }
});

$pageInput.on('blur', function() {
    goToPage();
});

function goToPage() {
    let val = parseInt($('#page-input').val(), 10);
    if (isNaN(val)) return;
    if (val < 1) val = 1;
    if (val > pdfDoc.numPages) val = pdfDoc.numPages;

    const $canvas = $(`#viewer canvas[data-page-num="${val}"]`);
    if ($canvas.length) {
        $('html, body').scrollTop($canvas.offset().top);
    }
    $('#page-input').val(val);
}

function setSelectValue($select, val) {
    let exists = $select.find(`option[value="${val}"]`).length > 0;
    if (!exists) {
        const $newOption = $(`<option class="temp-option" value="${val}">${Math.round(val*100)}%</option>`);

        let inserted = false;
        $select.find('option').each(function() {
            const optionVal = parseFloat($(this).val());
            if (!isNaN(optionVal) && optionVal > val) {
                $newOption.insertBefore($(this));
                inserted = true;
                return false;
            }
        });

        if (!inserted) {
            $select.append($newOption);
        }
    }
    $select.val(val);
}

function roundToNearest10(val) {
    return Math.round(val * 100 / 10) * 10 / 100;
}

function initCanvas() {
    pdfDoc.getPage(1).then(p => {
        const vp = p.getViewport({ scale: 1 });
        const width = $viewer.width() - 40;
        const max = width / vp.width;
        if (max > 1) {
            $zoomSelect.val('1');
            setScale(1);
        } else {
            $zoomSelect.val('page-width');
            setScale(max);
        }
        renderAllPages();
    });
}